import $ from 'jquery'

export const showError = msg => {

  if ( typeof msg !== 'string' )
    msg = 'An error occurred. Please check your Internet connection.'

  console.error( msg );
}
